import type { FC } from 'react';
import { Pagination } from '@packages/shared';
import { usePaging } from '../../hooks/usePaging';

export type ProductListPaginationProps = {
  /** prop description for storybook args table */
  /** optional pageCount
   * @default 1
   */
  pageCount?: number;
};

/**
 * ProductListPagination component description displayed in storybook
 * */
export const ProductListPagination: FC<ProductListPaginationProps> = ({ pageCount }) => {
  const { currentPage, pushPageChange } = usePaging();
  return (
    <Pagination
      shape="rounded"
      count={pageCount}
      page={currentPage}
      onChange={(e, value) => pushPageChange(value)}
      color="primary"
    />
  );
};
